<template>
    <div class="contact-card pt-0">
      <app-row class="ma-0 pa-0 align-content-center align-center justify-center">
        <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="5">
        </app-col>
        <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="2" md="2">
          <vue-flip style="height: 250px !important;width: 230px !important;" :key="1" :active-hover="true" :active-click="false" class="pa-0 ma-0 align-content-center justify-content-center" :class="AppIsMobile?`ms-13`:``" justify="center" width="201px" height="200px" align="center">
            <template v-slot:front style="width: 100% !important;">
              <v-responsive :aspect-ratio="16/9" class="align-center" style="width: 100% !important;height: 100% !important;">
                <v-img style="width: 225px !important;" :src="AppLogo"></v-img>
              </v-responsive>
            </template>
            <template v-slot:back style="width: 100% !important; background: transparent !important;">
              <v-responsive :aspect-ratio="16/9" class="align-center" style="width: 100% !important;height: 100% !important;">
                <v-img :src="AppLogo"></v-img>
              </v-responsive>
            </template>
          </vue-flip>
        </app-col>
        <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="5">
        </app-col>
      </app-row>
        <app-row class="ma-0 pa-0 align-content-center align-center justify-center">
          <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="12" md="12">
          <p class="contact-subtitle">{{parseAttribute('welc')}}</p>
        <div v-if="successMessage" class="alert alert-success text-center" role="alert">
          {{ successMessage }}
        </div>
          </app-col>
      </app-row>
        <form @submit.prevent="submit" novalidate>
          <app-row class="ma-0 pa-0 align-content-center align-center justify-center">
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="2" md="4">
              <app-text-input rules="fullname" md="12" sm="12" v-model="form.name" class="form-control pa-0" name="name" :placeholder="parseAttribute('enterfname')"></app-text-input>
              <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
          </app-row>
          <app-row class="ma-0 pa-0 align-content-center align-center justify-center">
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="2" md="4">
              <app-number-input rules="required|min:10" md="12" sm="12" v-model="form.mobile" class="form-control pa-0" name="mobile" placeholder="05xxxxxxxx"></app-number-input>
              <div class="invalid-feedback" v-if="errors.mobile">{{ errors.mobile[0] }}</div>
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
          </app-row>
          <app-row class="ma-0 pa-0 align-content-center align-center justify-center">
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="2" md="4">
              <app-text-input md="12" sm="12" rules="required|email" v-model="form.email" class="form-control pa-0":class="{ 'is-invalid': errors.email }" placeholder="example@email.com" name="email"></app-text-input>
              <div class="invalid-feedback" v-if="errors.email">{{ errors.email[0] }}</div>
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
          </app-row>
          <app-row class="ma-0 pa-0 align-content-center align-center justify-center">
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="2" md="4">
              <app-call-types md="12" sm="12" v-model="form.call_type" class="form-control pa-0" :placeholder="parseAttribute('callypetitle')" name="callypetitle"></app-call-types>
              <div class="invalid-feedback d-block" v-if="errors.call_type_id">{{ errors.call_type_id[0] }}</div>
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
          </app-row>
          <app-row class="ma-0 pa-0 align-content-center align-center justify-center">
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="2" md="4">
              <app-contact-types md="12" sm="12" v-model="form.contact_type" class="form-control pa-0"
                                 :placeholder="parseAttribute('contypetitle')" name="contypetitle"></app-contact-types>
              <div class="invalid-feedback d-block" v-if="errors.contact_type_id">{{ errors.contact_type_id[0] }}</div>
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="2" md="4">
              <app-text-input md="12" sm="12" v-model="form.address" class="form-control pa-0"
                              :placeholder="parseAttribute('msgtitle')" name="msgtitle" rules="required|max:255"></app-text-input>
              <div class="invalid-feedback d-block" v-if="errors.address">{{ errors.address[0] }}</div>
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
          </app-row>
          <app-row class="ma-0 pa-0 align-content-center align-center justify-center">
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="2" md="4">
              <app-textarea-input rules="required|max:5000" md="12" sm="12" name="msg" v-model="form.message" rows="5" class="form-control pa-0" style="border-color: #2a3686 !important;"
                                  :class="{ 'is-invalid': errors.message }" :placeholder="parseAttribute(isLogin ? 'wrmsg' : 'msg')"></app-textarea-input>
              <div class="invalid-feedback d-block" v-if="errors.message">{{ errors.message[0] }}</div>
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
          </app-row>
          <app-row class="ma-0 pa-0 align-content-center align-center justify-center">
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="2" md="4">
              <!-- Attachments are for registered members only -->
              <small v-if="!canAttach" class="text-muted d-block">
                <v-icon small>mdi-paperclip</v-icon> {{ parseAttribute('cc_attach_login') }}
              </small>
              <template v-else>
              <label class="form-label">{{ parseAttribute('attachment') }} <span class="optional">{{ parseAttribute('cc_optional') }}</span></label>
              <small class="text-muted d-block mb-1">{{ $t('cc_max_files', {count: maxAttachments}) }}</small>
              <!-- One field per allowed file, so files can come from different folders -->
              <div v-for="(slot, i) in slots" :key="i" class="attachment-slot mb-2">
                <div class="d-flex align-center">
                  <span class="slot-number me-2">{{ i + 1 }}</span>
                  <input type="file" :ref="`attachment${i}`" @change="onFileChange(i, $event)" class="form-control"
                         accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar"
                         :class="{ 'is-invalid': slotErrors[i] }">
                  <v-btn v-if="slot" icon small color="error" class="ms-1" :title="$t('delete')" @click="clearSlot(i)">
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                </div>
                <div class="invalid-feedback d-block" v-if="slotErrors[i]">{{ slotErrors[i] }}</div>
              </div>
              <small class="text-muted d-block mt-1">{{ parseAttribute('cc_attachment_hint') }}</small>
              </template>
              <div class="invalid-feedback d-block" v-if="attachmentError">{{ attachmentError }}</div>
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
          </app-row>
          <app-row v-if="recaptchaSiteKey" class="ma-0 pa-0 align-content-center align-center justify-center">
            <app-col class="ma-0 pa-0 mb-3 d-flex flex-column align-center" cols="12">
              <div ref="recaptcha"></div>
              <div class="invalid-feedback d-block text-center" v-if="errors['g-recaptcha-response']">{{ errors['g-recaptcha-response'][0] }}</div>
            </app-col>
          </app-row>
          <app-row class="ma-0 pa-0 align-content-center align-center justify-center">
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="2" md="4">
              <app-submit type="submit" style="font-size: 1rem;border-radius: 15px 0; background: #0b438d !important;color: #fff !important;--bs-btn-color: #fff !important;--bs-btn-bg: #0b438d !important;--bs-btn-border-color: #0b438d !important;--bs-btn-hover-color: #fff !important;--bs-btn-hover-bg: rgb(11 67 141) !important;--bs-btn-hover-border-color: rgb(11 67 141) !important;--bs-btn-focus-shadow-rgb: 49, 132, 253 !important;--bs-btn-active-color: #fff !important;--bs-btn-active-bg: rgb(11 67 141) !important;--bs-btn-active-border-color: rgb(11 67 141) !important;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125) !important;--bs-btn-disabled-color: #fff !important;--bs-btn-disabled-bg: #0b438d !important;--bs-btn-disabled-border-color: #0b438d !important;height: 50px !important;width: 35% !important;" class="btn-block" :disabled="loading">
                <span v-if="loading">{{parseAttribute('sending')}}</span>
                <span v-else>{{parseAttribute('sendmsg')}}</span>
              </app-submit>
            </app-col>
            <app-col class="ma-0 pa-0 align-content-center align-center justify-center" sm="5" md="4">
            </app-col>
          </app-row>
        </form>
      <v-dialog max-width="800" persistent v-model="verifyDialog" v-if="verifyDialog">
        <app-row class="ma-0" width="100%" style="background: #f9f9f9;" align="center" justify="center">
          <app-col class="pa-0" style="background: #f9f9f9;" cols="12">
            <v-card :loading="verifyLoading" elevation="12" flat loader-height="10" tile>
              <v-toolbar class="justify-content-center white--text" color="primary darken-2" max-height="40" height="40" dark flat>
                <v-toolbar-title>{{ $t('verify_email_title') }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="ma-0 pa-0">
                <app-col style="font-size: 20px;" class="ma-0 pa-0 ps-5 py-6 text-start text--primary text--darken-2" md="12" sm="12" xs="12">
                  {{$t('verify_email_text1')}}<span style="font-family: 'Kufi',ui-serif !important;" class="ps-5 red--text font-weight-bold text-h5">&nbsp;&nbsp;&nbsp;{{ sentEmail }}</span>
                </app-col>
                <app-col class="ma-0 pa-0 pt-4 pe-2 ps-5" md="12" sm="12" xs="12">
                  <app-row class="ma-0 pa-0">
                    <app-col class="ma-0 pa-0" md="10" sm="12" xs="12">
                      <app-number-input :loading="verifyLoading" class="ma-0 pa-0" clearable :counter="false" v-model="otpCode" name="verify_email_text2"/>
                    </app-col>
                    <app-col class="ma-0 pa-0 align-self-center" style="text-align: center !important;" md="2" sm="12" xs="12">
                      <app-btn :loading="verifyLoading" color="primary" class="ma-0 pa-0" @click="verifyCode">{{parseAttribute('cc_verify')}}</app-btn>
                    </app-col>
                  </app-row>
                </app-col>
                <app-col v-if="!showResend" style="font-size: 20px;" class="ma-0 pa-0 ps-5 pt-3 text-start" cols="12">{{$t('verify_email_text3')}}</app-col>
                <app-col cols="12" class="ma-0 mb-2 pa-0 pt-3 red--text text-h3 font-weight-bold" style="font-family: 'Kufi',ui-serif !important;text-align: center !important;">
                  {{ verificationTimer }}
                </app-col>
              </v-card-text>
              <v-divider/>
              <v-card-actions>
                <v-spacer></v-spacer>
                <app-btn :loading="verifyLoading" v-if="showResend" color="primary" class="ma-0 pa-0" @click="resendCode">{{parseAttribute('cc_request_new_code')}}</app-btn>
                <app-btn :loading="verifyLoading" color="error" min-width="120" tooltip="close_window" @click="closeVerifyDialog">{{ $t('close') }}</app-btn>
              </v-card-actions>
            </v-card>
          </app-col>
        </app-row>
      </v-dialog>
    </div>
</template>
<style>
.back{
  background: transparent !important;
}
.front{
  background: transparent !important;
}
</style>
<script>
import VueFlip from 'vue-flip';
export default {
  components: {
    'vue-flip': VueFlip
  },
    props: {
        action: { type: String, required: true },
        csrf: { type: String, default: '' },
    },

    data() {
      const meta = document.head.querySelector('meta[name="csrf-token"]');
        return {
            form: {
                name: '',
                mobile: '',
                email: '',
                contact_type: '',
                call_type: '',
                address: '',
                message: '',
            },
            // slots[i] = File selected in field i (null when empty)
            slots: [],
            // index in the sent attachments[] -> field index, to map server errors
            sentSlots: [],
            errors: {},
            loading: false,
            successMessage: '',
            appName: this.parseAttribute('apptit'),
            storeUrl: '/contactadd',
            verifyDialog: false,
            verifyLoading: false,
            contactId: null,
            sentEmail: '',
            otpCode: null,
            showResend: false,
            timeLeft: 0,
            timer: null,
            verificationTimer: '',
            recaptchaSiteKey: process.env.MIX_RECAPTCHA_SITE_KEY || '',
            recaptchaEnterprise: process.env.MIX_RECAPTCHA_ENTERPRISE === 'true',
            recaptchaToken: '',
            recaptchaWidget: null,
        };
    },
    mounted() {
        if (this.recaptchaSiteKey) this.loadRecaptcha();
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    watch: {
        maxAttachments: {
            immediate: true,
            handler(count) {
                const slots = this.slots.slice(0, count);
                while (slots.length < count) slots.push(null);
                this.slots = slots;
            },
        },
    },
    computed: {
        // Per-user allowance (users.max_attachments); guests cannot attach files.
        maxAttachments() {
            if (!this.isLogin) return 0;
            const user = (this.$root && this.$root.authUser) || {};
            const limit = parseInt(user.max_attachments, 10);
            return limit > 0 ? limit : 1;
        },
        canAttach() {
            return this.maxAttachments > 0;
        },
        // Errors that are not tied to one field (e.g. too many files, not logged in).
        attachmentError() {
            const errors = this.errors || {};
            const key = ['attachments', 'attachment'].find(k => errors[k]);
            return key ? errors[key][0] : '';
        },
        // Server errors for attachments.N mapped back to the field they came from.
        slotErrors() {
            const errors = this.errors || {};
            const result = {};
            this.sentSlots.forEach((slot, k) => {
                const e = errors[`attachments.${k}`];
                if (e) result[slot] = e[0];
            });
            return result;
        },
    },

    methods: {
        loadRecaptcha() {
            const api = () => (this.recaptchaEnterprise ? window.grecaptcha.enterprise : window.grecaptcha);
            const render = () => {
                if (!this.$refs.recaptcha || this.recaptchaWidget !== null) return;
                this.recaptchaWidget = api().render(this.$refs.recaptcha, {
                    sitekey: this.recaptchaSiteKey,
                    hl: this.AppLocale,
                    callback: (token) => { this.recaptchaToken = token; },
                    'expired-callback': () => { this.recaptchaToken = ''; },
                    'error-callback': () => { this.recaptchaToken = ''; },
                });
            };
            if (window.grecaptcha && api() && api().render) return render();
            window.onRecaptchaLoad = render;
            if (!document.getElementById('recaptcha-api')) {
                const el = document.createElement('script');
                el.id = 'recaptcha-api';
                el.async = true;
                el.src = 'https://www.google.com/recaptcha/' + (this.recaptchaEnterprise ? 'enterprise.js' : 'api.js') + '?onload=onRecaptchaLoad&render=explicit';
                document.head.appendChild(el);
            }
        },
        resetRecaptcha() {
            this.recaptchaToken = '';
            if (this.recaptchaWidget !== null && window.grecaptcha) {
                (this.recaptchaEnterprise ? window.grecaptcha.enterprise : window.grecaptcha).reset(this.recaptchaWidget);
            }
        },
        onFileChange(index, event) {
            const file = event.target.files && event.target.files[0];
            this.$set(this.slots, index, file || null);
            this.sentSlots = [];
        },
        clearSlot(index) {
            this.$set(this.slots, index, null);
            const input = this.$refs[`attachment${index}`];
            const el = Array.isArray(input) ? input[0] : input;
            if (el) el.value = '';
            this.sentSlots = [];
        },
        submit() {
            this.errors = {};
            if (this.recaptchaSiteKey && !this.recaptchaToken) {
                this.errors = { 'g-recaptcha-response': [this.parseAttribute('recaptcha_required')] };
                return;
            }
            this.loading = true;
            this.successMessage = '';

            const data = new FormData();
            data.append('name', this.form.name);
            data.append('mobile', this.form.mobile);
            data.append('email', this.form.email);
            data.append('address', this.form.address);
            data.append('message', this.form.message);
            if (this.recaptchaSiteKey) {
                data.append('g-recaptcha-response', this.recaptchaToken);
            }
            if (this.form.call_type) {
                data.append('call_type_id', this.form.call_type);
            }
            if (this.form.contact_type) {
                data.append('contact_type_id', this.form.contact_type);
            }
            this.sentSlots = [];
            if (this.canAttach) {
                this.slots.forEach((file, i) => {
                    if (file) {
                        data.append('attachments[]', file);
                        this.sentSlots.push(i);
                    }
                });
            }
            window.axios.post(this.action, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': this.csrf,
                },
            })
            .then((response) => {
                this.successMessage = response.data.message;
                this.contactId = response.data.data ? response.data.data.contact_id : null;
                this.sentEmail = this.form.email;
                this.otpCode = null;
                this.showResend = false;
                this.verifyDialog = true;
                this.timerRun();
                this.alertSuccess(this.successMessage);
            })
            .catch((error) => {
                if (error.response && error.response.status === 422 && error.response.data.errors) {
                    this.errors = error.response.data.errors || {};
                } else {
                    this.successMessage = '';
                  this.alertError(this.parseAttribute('errmsg'));
                }
            })
            .finally(() => {
                this.loading = false;
                this.resetRecaptcha();
            });
        },
        verifyCode() {
            if (this.verifyLoading) return;
            this.verifyLoading = true;
            window.axios.post('/contactverify', {
                contact_id: this.contactId,
                verification_code: this.otpCode,
            })
            .then((response) => {
                const reference = response.data.data && response.data.data.reference;
                this.successMessage = reference
                    ? `${response.data.message} — ${this.parseAttribute('cc_your_reference')}: ${reference}`
                    : response.data.message;
                this.alertSuccess(this.successMessage);
                this.closeVerifyDialog();
                this.resetForm();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            })
            .catch((error) => {
                const msg = error.response && error.response.data && error.response.data.message;
                this.alertError(msg || this.parseAttribute('errmsg'));
                this.otpCode = null;
            })
            .finally(() => {
                this.verifyLoading = false;
            });
        },
        resendCode() {
            if (this.verifyLoading) return;
            this.verifyLoading = true;
            window.axios.post('/contactresend', {
                contact_id: this.contactId,
            })
            .then((response) => {
                this.alertSuccess(response.data.message);
                this.otpCode = null;
                this.showResend = false;
                this.timerRun();
            })
            .catch((error) => {
                const msg = error.response && error.response.data && error.response.data.message;
                this.alertError(msg || this.parseAttribute('errmsg'));
            })
            .finally(() => {
                this.verifyLoading = false;
            });
        },
        timerRun() {
            clearInterval(this.timer);
            this.timeLeft = 60;
            this.verificationTimer = this.timeLeft;
            this.timer = setInterval(() => {
                if (this.timeLeft <= 0) {
                    clearInterval(this.timer);
                    this.showResend = true;
                    this.verificationTimer = '';
                } else {
                    this.timeLeft = this.timeLeft - 1;
                    this.verificationTimer = this.timeLeft;
                }
            }, 1000);
        },
        closeVerifyDialog() {
            clearInterval(this.timer);
            this.verifyDialog = false;
            this.otpCode = null;
            this.showResend = false;
            this.timeLeft = 0;
            this.verificationTimer = '';
        },
        resetForm() {
            this.form = { name: '', mobile: '', email: '', contact_type: '', call_type: '', address: '', message: '' };
            this.slots.forEach((_, i) => this.clearSlot(i));
            this.sentSlots = [];
        },
    },
};
</script>

<style scoped>
.contact-card {
    border-radius: 14px;
    padding: 32px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 auto;
}
.contact-title {
    text-align: center;
    font-weight: 700;
    color: #0d6efd;
    margin-bottom: 6px;
}
.contact-subtitle {
    text-align: center;
    color: #6b7280;
    margin-bottom: 24px;
}
.form-label {
    font-weight: 600;
    margin-bottom: 6px;
}
.req { color: #dc3545; }
.optional { color: #9ca3af; font-weight: 400; font-size: 0.85em; }
.slot-number {
    min-width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #0b438d;
    color: #fff;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
</style>
